import * as React from 'react';
import { AdsSwappingContext } from 'src/common/stores/contexts/adsSwapping/ads-swapping-context';
import { MesoDisplayAd } from 'components/meso/meso-display-ad';
import { DisplayAd } from 'constants/ads';
const R1WithAdSwap = React.memo(({
  isEnabled
}) => React.createElement(MesoDisplayAd, Object.assign({}, DisplayAd.SIDERAIL_R1, {
  adSwapEnabled: true,
  isEnabled: isEnabled
})));
const R2WithAdSwap = React.memo(({
  isEnabled
}) => React.createElement(MesoDisplayAd, Object.assign({}, DisplayAd.SIDERAIL_R2, {
  adSwapEnabled: true,
  isEnabled: isEnabled
})));
export const AdsBySwapping = () => {
  const {
    isFirstAdOnTop,
    adLoadState
  } = React.useContext(AdsSwappingContext);
  const adStyleFirst = {
    display: isFirstAdOnTop && adLoadState.r1 || !adLoadState.r2 ? 'block' : 'none'
  };
  const adStyleSecond = {
    display: adLoadState.r2 && (!isFirstAdOnTop || adLoadState.r1 === false) ? 'block' : 'none'
  };
  /*
   * The "enabled" state for a meso-display-ad component controls whether the creative content is fetched and rendered into the iframe.
   * A rendered impression is fired automatically when this happens.
   * Due to limitations in the core GPT library, we cannot control the creative render and impression beacon separately.
   * Therefore, it is best to only initiate render lifecycle when certain criteria is met.
   *
   * The logic to enable R2 is as follows:
   * - R2 is on "top" according to scroll position (standard case, show once user scrolls)
   * - R1 has been fetched but has no content (try to show R2 instead)
   */
  return React.createElement("div", {
    "data-stid": "ads-by-swapping"
  }, React.createElement("div", {
    style: adStyleFirst
  }, React.createElement(R1WithAdSwap, {
    isEnabled: true
  })), React.createElement("div", {
    style: adStyleSecond
  }, React.createElement(R2WithAdSwap, {
    isEnabled: !isFirstAdOnTop || adLoadState.r1 === false
  })));
};